// reducers.js
import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
export const LOGIN_SESSION_KEY = "LOGINSESSION_KEY";
export const PROVIDER = "PROVIDER";
export const PROVIDER_IDENTIFIER = "PROVIDER_IDENTIFIER";

const initialState = {
  accountBalance: null,
  isInternalAccount: false,
  showTooltip: true,
  showBalanceAlert: false,
  goalCardType: "",
  showTooltipForSavings: true,
  kudzuPlusTrue: false,
  fromSmiOne : false,
  smiOneSSN :'',
  smiOneCardKey :'',
  smiOneLastDigitCardNo :'',
  isSignUpkudzuPlusTrue: false,
  isSignUpKudzuplusTrial:false,
  isSignKudzuplusTrial:false,
  isSignKudzuplusData: false,
  welcomeCarouselSkipValue: false,
  ShowPromptsTrue: false,
  isComparisionScreen: false,
  kudzuPlusResponse: {},
  climbPopShowValue: false,
  showSearchOnHome: false,
  membershipType: '',
  smiOneNewCreatedPassword: '',
  SearchFiltervalue: '',
  smiOneId : '',
  kudzuFlowFrom: "",
  currentPathFromStore: "",
  cipReferResponse: {
  },
  savingGoalAccountTypeObj :{},
  manageSavingGoalDetailsData :{},
  idoloyResponse: {},
  showTooltip: true,
  mobileNumber: '',
  showTooltipForSavings: true,
  ShowPromptsTrue:false,
  isComparisionScreen:false,
  fromExtendFlow:false,
  kudzuPlusResponse:{},
  climbPopShowValue:false,
  showSearchOnHome: false,
  SearchFiltervalue: '',
  deviceId: null,
  preferredIdentity: false,
  modalvalueSavingGoal :false,
  errorModalvalueSavingGoal :false,
  errorAllocateModal :false,
  succesModalAllocateFund: false,
  payperksDays: null,
  payperksURL: null,
  payperksError: null,
  issuerURL:"",
  emailFromProvider:"",
  isLoginDeviceTrusted: false,
  accessToken: null,
  userLanguage: null,
  userProfile: null,
  loggedInResponse: null,
  userCards: null,
  userActivities: null,
  isDeviceVerifiedCalled: null,
  sessionId: null,
  userId: null,
  loggedSessionKey: "0",
  isMobileVerifed: false,
  userEmail: null,
  isLoggedIn: false,
  deepLinkPath: "",
  signUpMobile: "",
  twoFactAuthenticationDone: false,
  userAlerts: null,
  spendAlertCount: null,
  spendsSelctedId: null,
  savingsHABSelectedId: null,
  documentAgreementType: null,
  appConfigData: null,
  preferredName: "",
  savingsAccontAvailable: null,
  savingsNewClicked: false,
  signUpReferralCode: null,
  signUpAccessCode: null,
  transferMoneyPayload: {
    FromAccount: null,
    ToAccount: null,
    Amount: null,
    Frequency: { displayText: "" },
    FrequencyType: null,
    TransferDate: null,
    startDate: null,
    EndDate: null,
    Memo: null,
  },
  spendAlertsPayload: {
    amount: null,
    frequencyType: null,
    startDate: null,
    email: false,
    sms: true,
    push: true,
  },
  notifications: null,
  notificationCountPerPage: 8,
  selectedFrequencyValue: {},
  notificationUnreadCount: null,
  savingsHabitData: {
    SavingHabitType: "Percent-based (%)",
    Percent: null,
    Amount: null,
    Frequency: null,
    StartDate: null,
  },
  allocateFund: { 
    // AccountsType: null,
    Installments: null,
    Frequency: null,
    StartDate: null,
    email: false,
    sms: false,
  },
  savingGoals: { 
    Amount: null,
    Name: null,
  },
  frequecyData : [],
  signUpEmail : null,
  accountTypes : [],
  manageSavingData : [],
  manageSavingTotalCount : "",
  savingGoalResonseMsg : [],
  allocateFundResonseMsg : [],
  savingGoalResponseData:{},
  smiOneKudzuResponseData:{},
  activeSavingsHabitCount: 0,
  climbFeatures: null,
  isEditBenificirey: null,
  benficaryKey: null,
  addedBenficaryDetails: {
    firstName: "",
    lastName: "",
    ssn: "",
    apt_etc: "",
    selectedDobToServer: "",
    birthDay: "",
    formattedAddress: "",
    line1: "",
    line2: "",
    city: "",
    state: "",
    zipCode: "",
    countryCode: "",
    country: "",
    cardKey: "",
  },
  isAcceptAgreement: false,
  addedAuthorizedUserDetails: {
    firstName: "",
    lastName: "",
    ssn: "",
    apt_etc: "",
    selectedDobToServer: "",
    birthDay: "",
    formattedAddress: "",
    line1: "",
    line2: "",
    city: "",
    state: "",
    zipCode: "",
    countryCode: "",
    country: "",
    cardKey: "",
    phoneNumber: "",
    emailAddress: "",
  },
  signupTermsAndConditionCheckbox: {
    privacy_user: false,
    deposit_savings: false,
    electronic_aggrement: false,
    savings_account_aggrement: false,
    penalty_perjury: false
  },
  selectedCardDetails: null,
  ssnScreenThrough: "",
  savingsTermsConditions: false,
  selectedSubIndex: "",
  signUpPersonelInfo: null,
  signUpTermsAndConditions: null,
  transferAccounts: null,
  cancelTransactionDetails: null,
  selectedCardTab: '',
  successfulTransferResponse: null,
  studentEmailAddress: "",
  studentUniversityCode: "",
  studentUniversityName: "",
  graduationDate: "",
  closeIconFromStore: false,
  kudzuPlusModal: false,
  cbkTransactionDetails:null,
  b2cEnabled: false,
  smiOneAccountTrue:false,
  toolTipstepIndex: 0, // Tracks current step
  toolTiprun: true,
  isClimbShow:false,
  isSideBarOpen:false,
  SidebartoolTipstepIndex: 0,
  anyInAppNotifications:false
};

// //  showSearchOnHome:false,
// SearchFiltervalue:'',

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SHOW_TOOLTIP":
      return {
        ...state,
        showTooltip: action.payload.showTooltip,
      };
    case "KUDZU_PLUS_MODAL":
      return {
        ...state,
        kudzuPlusModal: action.payload.kudzuPlusModal,
      };
    case "KUDZU_PLUS_TRUE":
      return {
        ...state,
        kudzuPlusTrue: action.payload.kudzuPlusTrue,
      }; 
    case "FROM_SMI_ONE":
      return {
        ...state,
        fromSmiOne: action.payload.fromSmiOne,
      }; 
      
    case "IS_SIGNUP_KUDZU_PLUS_TRUE_DATA":
      return {
        ...state,
        isSignUpKudzuplusTrueData: action.payload.isSignUpKudzuplusTrueData,
      };
    case "FREQUESCY_DATA":
      return {
        ...state,
        frequecyData: action.payload.frequecyData,
      };
    case "SIGNUP_EMAIL":
      return {
        ...state,
        signUpEmail: action.payload.signUpEmail,
      };
    case "ACCOUNT_TYPES_DATA":
      return {
        ...state,
        accountTypes: action.payload.accountTypes,
      };
    case "MANAGE_SAVING_DATA":
      return {
        ...state,
        manageSavingData: action.payload.manageSavingData,
      };
    case "MANAGE_SAVING_TOTAL_COUNT":
      return {
        ...state,
        manageSavingTotalCount: action.payload.manageSavingTotalCount,
      };
    case "SAVING_GOAL_RESPONSE_MSG":
      return {
        ...state,
        savingGoalResonseMsg: action.payload.savingGoalResonseMsg,
      };
    case "ALLOCATE_FUND_RESPONSE_MSG":
      return {
        ...state,
        allocateFundResonseMsg: action.payload.allocateFundResonseMsg,
      };
    case "SAVING_GOAL_RESPONSE_DATA":
      return {
        ...state,
        savingGoalResponseData: action.payload.savingGoalResponseData,
      };
    case "SMI_ONE_KUDZU_RESPONSE_DATA":
      return {
        ...state,
        smiOneKudzuResponseData: action.payload.smiOneKudzuResponseData,
      };

      case "IS_SIGNUP_KUDZU_PLUS_TRIAL":
        return {
          ...state,
          isSignUpKudzuplusTrial : action.payload.isSignUpKudzuplusTrial,
        }

    case "IS_SIGNUP_KUDZU_PLUS_TRUE":
      return {
        ...state,
        isSignUpKudzuplusTrue: action.payload.isSignUpKudzuplusTrue,
      };

    case "WELOCME_CAROUSEL_SKIP":
      return {
        ...state,
        welcomeCarouselSkipValue: action.payload.welcomeCarouselSkipValue,
      };

    case "MEMEBERSHIP_TYPE":
      return {
        ...state,
        membershipType: action.payload.membershipType,
      };
    case "SMI_ONE_SSN_NUMBER":
      return {
        ...state,
        smiOneSSN: action.payload.smiOneSSN,
      };
    case "SMI_ONE_CARD_KEY":
      return {
        ...state,
        smiOneCardKey: action.payload.smiOneCardKey,
      };
    case "SMI_ONE_LAST_DIGIT_CARD_NO":
      return {
        ...state,
        smiOneLastDigitCardNo: action.payload.smiOneLastDigitCardNo,
      };
    case "SMI_ONE_NEW_CREATED_PASSWORD":
      return {
        ...state,
        smiOneNewCreatedPassword: action.payload.smiOneNewCreatedPassword,
      };
    case "SHOW_PROMPT_TRUE":
      return {
        ...state,
        ShowPromptsTrue: action.payload.ShowPromptsTrue,
      };
    case "COMPARISON_SCREEN":
      return {
        ...state,
        isComparisionScreen: action.payload.isComparisionScreen,
      };
    case "KUDZU_PLUS_ACCOUNT_RESPONSE":
      return {
        ...state,
        kudzuPlusResponse: action.payload.kudzuPlusResponse,
      };

    case "KUDZU_PLUS_FROM":
      return {
        ...state,
        kudzuFlowFrom: action.payload.kudzuFlowFrom,
    };
    case "SMI_ONE_ID":
      return {
        ...state,
        smiOneId: action.payload.smiOneId,
    };
    case "FROM_EXTEND_FLOW":
      return {
        ...state,
        fromExtendFlow: action.payload.fromExtendFlow,
    };
    case "CURRENT_LOCATION":
      return {
        ...state,
        currentPathFromStore: action.payload.currentPathFromStore,
      };
    case "CLIMB_POPUP_SHOWVALUE":
      return {
        ...state,
        climbPopShowValue: action.payload.climbPopShowValue,
      };
    case "CIP_STATUS_REFER":
      return {
        ...state,
        cipReferResponse: action.payload.cipReferResponse,
      };
    case "IDOLOGY_RESPONSE":
      return {
        ...state,
        idoloyResponse: action.payload.idoloyResponse,
      };
    case "SAVING_GOAL_ACCOUNT_TYPE_OBJ":
      return {
        ...state,
        savingGoalAccountTypeObj: action.payload.savingGoalAccountTypeObj,
      };
    case "MANAGE_SAVING_GOAL_DETAILS_OBJ":
      return {
        ...state,
        manageSavingGoalDetailsObj: action.payload.manageSavingGoalDetailsObj,
      };
    case "NAME_CHANGED_IN_CIP":
      return {
        ...state,
        nameChanged: action.payload.nameChanged,
      };
    case "CLOSE_ICON_FROM_STORE":
      return {
        ...state,
        closeIconFromStore: action.payload.closeIconFromStore,
      };
    case "SHOW_TOOLTIP_FOR_SAVING":
      return {
        ...state,
        showTooltipForSavings: action.payload.showTooltipForSavings,
      };
    case "SHOW_SEARCH_ON_HOME":
      return {
        ...state,
        showSearchOnHome: action.payload.showSearchOnHome,
      };
    case "SEARCH_FILTER_VALUE":
      return {
        ...state,
        SearchFiltervalue: action.payload.SearchFiltervalue,
      };
    case "DEVICE_ID":
      return {
        ...state,
        deviceId: action.payload.deviceId,
      };
    case "PREFERRED_IDENTITY_SERVICE":
      return {
        ...state,
        preferredIdentity: action.payload.preferredIdentity,
      };
    case "MODAL_SAVING_GOAL":
      return {
        ...state,
        modalvalueSavingGoal: action.payload.modalvalueSavingGoal,
      };
    case "ERROR_MODAL_SAVING_GOAL":
      return {
        ...state,
        errorModalvalueSavingGoal: action.payload.errorModalvalueSavingGoal,
      };
    case "ERROR_ALLOCATE_MODAL":
      return {
        ...state,
        errorAllocateModal: action.payload.errorAllocateModal,
      };
    case "SUCCESS_MODAL_ALLOCAT_FUND":
      return {
        ...state,
        succesModalAllocateFund: action.payload.succesModalAllocateFund,
      };
    case "SELECTED_FREQUENCY_VALUE":
      return {
        ...state,
        selectedFrequencyValue: action.payload.selectedFrequencyValue,
      };
    case "PAYPERKS_DAYS":
      return {
        ...state,
        payperksDays: action.payload.payperksDays,
      };
    case "UPDATE_PREFERRED_NAME":
      return {
        ...state,
        preferredName: action.payload.preferredName,
      };
    case "PAYPERKS_DASHBOARD_URL":
      return {
        ...state,
        payperksURL: action.payload.payperksURL,
      };
    case "PAYPERKS_ERROR":
      return {
        ...state,
        payperksError: action.payload.payperksError,
      };
    case "ACCESS_TOKEN":
      return {
        ...state,
        accessToken: action.payload.accessToken,
      };

    case LOGIN_SESSION_KEY:
      return {
        ...state,
        loggedSessionKey: action.payload.loggedSessionKey,
      };

    case "SAVINSGS_AVAILABLE":
      return {
        ...state,
        savingsAccontAvailable: action.payload.savingsAccontAvailable,
      };
    case "UPDATE_SIGNUP_REFERRAL_CODE":
      return {
        ...state,
        signUpReferralCode: action.payload.signUpReferralCode,
      }
    case "UPDATE_SIGNUP_ACCESS_CODE":
      return {
        ...state,
        signUpAccessCode: action.payload.signUpAccessCode,
      }
    case "SAVINSGS_DISABLED":
      return {
        ...state,
        savingsNewClicked: action.payload.savingsNewClicked,
      };

    case "DEVICE_VERIFIED_CALLED":
      return {
        ...initialState,
        isDeviceVerifiedCalled: action.payload.isDeviceVerifiedCalled,
      };
    case "EDIT_BENFICIRIES":
      return {
        ...state, // Keep the existing state properties
        isEditBenificirey: action.payload.isEditBenificirey,
      };
    case "BENFICIRIEY_KEY":
      return {
        ...state, // Keep the existing state properties
        benficaryKey: action.payload.benficaryKey,
      };
    case "UPDATE_ACCESS_TOKEN":
      return {
        ...state,
        accessToken: action.payload.accessToken,
      };
    case "UPDATE_LOGIN_DEVICE_TRUSTED":
      return {
        ...state,
        isLoginDeviceTrusted: action.payload.isLoginDeviceTrusted,
      };
    case "USER_ALERTS":
      return {
        ...state,
        userAlerts: action.payload.userAlerts,
      };
    case "TRANSFER_MONEY_PAYLOAD":
      return {
        ...state,
        transferMoneyPayload: {
          ...state.transferMoneyPayload,
          [action.payload.key]: action.payload.value,
        },
      };
    case "RESET_TRANSFER_PAYLOAD":
      return {
        ...state,
        transferMoneyPayload: initialState.transferMoneyPayload,
      };
    case "SAVINGS_HABIT_DATA":
      return {
        ...state,
        savingsHabitData: {
          ...state.savingsHabitData,
          [action.payload.key]: action.payload.value,
        },
      };
    case "ALLOCATE_FUND":
      return {
        ...state,
        allocateFund: {
          ...state.allocateFund,
          [action.payload.key]: action.payload.value,
        },
      };
    case "SAVING_GOALS":
      return {
        ...state,
        savingGoals: {
          ...state.savingGoals,
          [action.payload.key]: action.payload.value,
        },
      };
    case "SAVINGS_HABIT_ACTIVE_COUNT":
      return {
        ...state,
        activeSavingsHabitCount: action.payload.activeCount,
      };
    case "UPDATE_AGREEMENT_TYPE":
      return {
        ...state,
        documentAgreementType: action.payload.documentAgreementType,
      };
    case "RESET_AGREEMENT_TYPE":
      return {
        ...state,
        documentAgreementType: initialState.documentAgreementType,
      };
    case "RESET_SMI_ONE_LAST_DIGIT_CARD_NO":
      return {
        ...state,
        smiOneLastDigitCardNo: initialState.smiOneLastDigitCardNo,
      };

    case "UPDATE_CLIMB_FEATURE":
      return {
        ...state,
        climbFeatures: action.payload.climbFeatures,
      };
    case "UPDATE_CLIMB_FEATURE_ITEM":
      const code = action.payload.code;
      const featueObjIndex = state.climbFeatures.findIndex(
        (item) => item.code === code
      );
      const updateObj = {
        ...state.climbFeatures[featueObjIndex],
        [action.payload.key]: action.payload.value,
      };
      state.climbFeatures[featueObjIndex] = updateObj;
      return {
        ...state,
        // climbFeatures: [action.payload.climbFeatures],
      };
    case "RESET_SAVINGS_HABIT_DATA":
      return {
        ...state,
        savingsHabitData: initialState.savingsHabitData,
      };
    case "RESET_ALLOCATE_FUND":
      return {
        ...state,
        allocateFund: initialState.allocateFund,
      };
    case "RESET_SAVING_GOALS":
      return {
        ...state,
        savingGoals: initialState.savingGoals,
      };
    case "ADD_SPEND_ALERTS":
      return {
        ...state,
        spendAlertsPayload: {
          ...state.spendAlertsPayload,
          [action.payload.key]: action.payload.value,
        },
      };
    case "RESET_SAVINGS_HABIT_DATA":
      return {
        ...state,
        savingsHABSelectedId: initialState.savingsHABSelectedId,
      };

    case "RESET_ADD_SPEND_ALERTS":
      return {
        ...state,
        spendAlertsPayload: initialState.spendAlertsPayload,
      };
    case "UPDATE_USER_LANGUAGE":
      return {
        ...state,
        userLanguage: action.payload.userLanguage,
      };
    case "UPDATE_USER_PROFILE":
      return {
        ...state,
        userProfile: action.payload.userProfile,
      };
    case "UPDATE_USER_CARDS":
      return {
        ...state,
        userCards: action.payload.userCards,
      };
    case "LOGGED_IN_RESPONSE":
      return {
        ...state,
        loggedInResponse: action.payload.loggedInResponse,
      };
    case "UPDATE_USER_CARD_BALANCE":
      const balance = action.payload.balance;
      const cardType = action.payload.cardType;
      const updatedUserCard =
        cardType === "Checking"
          ? [
            { ...state.userCards[0], Balance: balance },
            { ...state.userCards[1] },
          ]
          : [
            { ...state.userCards[0] },
            { ...state.userCards[1], Balance: balance },
          ];
      return {
        ...state,
        userCards: updatedUserCard,
      };
    case "SELECTED_USER_CARD_DETAILS":
      return {
        ...state,
        selectedCardDetails: action.payload.selectedCardDetails,
      };
    case "SUCCESSFUL_TRANSFER_RESPONSE":
      return {
        ...state,
        successfulTransferResponse: action.payload.successfulTransferResponse,
      };


    case "ADD_SPEND_ID":
      return {
        ...state,
        spendsSelctedId: action.payload.spendsSelctedId,
      };
    case "ADD_SAVNIGS_HAB_ID":
      return {
        ...state,
        savingsHABSelectedId: action.payload.savingsHABSelectedId,
      };
    case "UPDATE_USER_ACTIVITIES":
      return {
        ...state,
        userActivities: action.payload.userActivities,
      };
    case "UPDATE_USER_EMAIL":
      return {
        ...state,
        userEmail: action.payload.userEmail,
      };
    case "UPDATE_NOTIFICATIONS":
      return {
        ...state,
        notifications: action.payload.notifications,
      };
    case "UPDATE_NOTIFICATIONS_COUNT_PER_PAGE":
      return {
        ...state,
        notificationCountPerPage: action.payload.notificationCountPerPage,
      };
    case "UPDATE_NOTIFICATIONS_UNREAD_COUNT":
      return {
        ...state,
        notificationUnreadCount: action.payload.notificationUnreadCount,
      };
    case "SESSION_ID":
      return {
        ...state,
        sessionId: action.payload.sessionId,
      };
    case "USER_ID":
      return {
        ...state,
        userId: action.payload.userId,
      };
    case "MOBILE_VERIFIED":
      return {
        ...state,
        isMobileVerifed: action.payload.isMobileVerifed,
      };
    case "LOG_IN":
      return {
        ...state,
        isLoggedIn: action.payload.isLoggedIn,
      };
    case "DEEPLINK_PATH":
      return {
        ...state,
        deepLinkPath: action.payload.deepLinkPath,
      };
    case "TWOFACT_DONE":
      return {
        ...state,
        twoFactAuthenticationDone: action.payload.twoFactAuthenticationDone,
      };
    case "ADDED_BENFICARYDETAILS":
      return {
        ...state,
        addedBenficaryDetails: action.payload.addedBenficaryDetails,
      };
    case "ADDED_AUTHORZIED_USER":
      return {
        ...state,
        addedAuthorizedUserDetails: action.payload.addedAuthorizedUserDetails,
      };
    case "SIGNUP_MOBILE":
      return {
        ...state,
        signUpMobile: action.payload.signUpMobile,
      };
    case "STORE_APPCONFIGDATA":
      return {
        ...state,
        appConfigData: action.payload.appConfigData,
      };
    case "LOGOUT":
      return {
        ...state,
        isLoginDeviceTrusted: false,
        signUpMobile: "",
        accessToken: null,
        userLanguage: null,
        userProfile: null,
        // userCards: null,
        loggedInResponse: null,
        userActivities: null,
        isDeviceVerifiedCalled: null,
        sessionId: null,
        userId: null,
        loggedSessionKey: "0",
        isMobileVerifed: false,
        userEmail: null,
        isLoggedIn: false,
        deepLinkPath: "",
        twoFactAuthenticationDone: false,
        isEditBenificirey: null,
        isAcceptAgreement: false,
        spendAlertCount: null,
        appConfigData: null,
        ssnScreenThrough: "",
        savingsTermsConditions: false,
        selectedSubIndex: "",
        signUpPersonelInfo: null,
        savingsAccontAvailable: null,
        signUpTermsAndConditions: null,
        transferAccounts: null,
        cancelTransactionDetails: null,
        successfulTransferResponse: null,
        studentEmailAddress: "",
        studentUniversityCode: "",
        studentUniversityName: "",
        graduationDate: "",
        smiOneAccountTrue:false
      };
    case PROVIDER_IDENTIFIER:
      return {
        ...state,
        providerIdentifier: action.payload.providerIdentifier,
      };
    case "B2C_ENABLED":
      return {
        ...state,
        b2cEnabled: action.payload.b2cEnabled,
      }
    case "ISSUE_URL_FROM_MICROSOFT_PROVIDER":
      return {
        ...state,
        issuerURL: action.payload.issuerURL,
      };
    case "EMAIL_FROM_PROVIDER":
      return {
        ...state,
        emailFromProvider: action.payload.emailFromProvider,
      };
    case PROVIDER:
      return {
        ...state,
        provider: action.payload.provider,
      };
    case "IS_ACCEPT_AGREEMENT":
      return {
        ...state,
        isAcceptAgreement: action.payload.isAcceptAgreement,
      };
    case "SPENDS_ALERT_COUNT":
      return {
        ...state,
        spendAlertCount: action.payload.spendAlertCount,
      };
    case "SSN_SCREEN_THROUGH":
      return {
        ...state,
        ssnScreenThrough: action.payload.ssnScreenThrough,
      };
    case "SAVINGS_TERMS_CONDITIONS":
      return {
        ...state,
        savingsTermsConditions: action.payload.savingsTermsConditions,
      };
    case "SELECTED_SUB_INDEX":
      return {
        ...state,
        selectedSubIndex: action.payload.selectedSubIndex,
      };
    case "SIGN_UP_PERSONEL_INFO":
      return {
        ...state,
        signUpPersonelInfo: action.payload.signUpPersonelInfo,
      };
    case "SIGN_UP_TERMS_AND_CONDITIONS":
      return {
        ...state,
        signUpTermsAndConditions: action.payload.signUpTermsAndConditions,
      };
    case "UPDATE_SIGN_UP_TERMS_CHECKBOX":
      return {
        ...state,
        signupTermsAndConditionCheckbox: {
          ...state.signupTermsAndConditionCheckbox,
          [action.payload.key]: action.payload.value
        }
      }
    case "RESET_SIGN_UP_TERMS_CHECKBOX":
      return {
        ...state,
        signupTermsAndConditionCheckbox: initialState.signupTermsAndConditionCheckbox,
      };

    case "TRANSFER_ACCOUNTS":
      return {
        ...state,
        transferAccounts: action.payload.transferAccounts,
      };
    case "SELECTED_CARD_TAB":
      return {
        ...state,
        selectedCardTab: action.payload.selectedCardTab,
      };
    case "CANCEL_TRANSFER_DETAILS":
      return {
        ...state,
        cancelTransactionDetails: action.payload.cancelTransactionDetails,
      };
    case "CBK_TRANSACTION_DETAILS":
      return {
        ...state,
        cbkTransactionDetails: action.payload.cbkTransactionDetails,
      };
    case "STUDENT_EMAIL_VALUE":
      return {
        ...state,
        studentEmailAddress: action.payload.studentEmailAddress,
      };
    case "STUDENT_UNIVERSITY_CODE":
      return {
        ...state,
        studentUniversityCode: action.payload.studentUniversityCode,
      };
    case "STUDENT_UNIVERSITY_NAME":
      return {
        ...state,
        studentUniversityName: action.payload.studentUniversityName,
      };
    case "GRADUATION_DATE":
      return {
        ...state,
        graduationDate: action.payload.graduationDate,
      };
    case "SMIONE_ACCOUNT_TRUE":
      return {
        ...state,
        smiOneAccountTrue: action.payload.smiOneAccountTrue,
      };
   
      case "HOME_TOOLTIP_TOUR_NEXT_STEP":
        return {
          ...state,
          toolTipstepIndex:  action.payload.toolTipstepIndex,
        };
        case "SIDEBAR_TOOLTIP_TOUR_NEXT_STEP":
        return {
          ...state,
          SidebartoolTipstepIndex:  action.payload.SidebartoolTipstepIndex,
        };
    case "STOP_TOOL_TIP_TOUR":
      return {
        ...state,
        toolTiprun: false,
      };
    case "SHOW_BALANCE_ALERT":
      return {
        ...state,
        showBalanceAlert : action.payload.showBalanceAlert
      }
    case "GOAL_CARD_TYPE":
      return {
        ...state,
        goalCardType : action.payload.goalCardType
      }
    case "ACCOUNT_BALANCE":
      return {
        ...state,
        accountBalance : action.payload.accountBalance
      }
    case "IS_INTERNAL_ACCOUNT":
      return {
        ...state,
        isInternalAccount: action.payload.isInternalAccount
      }
      case "CIP_FLOW_IDOLOGY":
        return {
          ...state,
          cipFlowResp: action.payload.cipFlowResp,
        };
        case "SET_OTHER_DISABLED_STATE":
          return {
            ...state,
            isOtherDisabled: action.payload
          };
    case "IS_CLIMB_SHOW ":
      return {
        ...state,
        isClimbShow: action.payload.isClimbShow
      }
    case "SIDE_BAR_OPEN":
      return {
        ...state,
        isSideBarOpen: action.payload.isSideBarOpen
      };
    case "CBK_TRANSACTIONS":
      return {
        ...state,
        notifications: action.payload.notifications
    };
    case "CBK_TRANSACTIONS_ITEM":
      return {
        ...state,
        notificationsItem: action.payload.notificationsItem
    };
    case "MAIN_BALANCE":
      return {
        ...state,
        mainBalance: action.payload.mainBalance
    };
    case "ANY_IN_APP_NOTIFICATIONS":
      return {
        ...state,
        anyInAppNotifications: action.payload.anyInAppNotifications
      };
    case "COMPLETE_SAVING_GOAL_DATA":
      return {
        ...state,
       completeSavingGoalData: action.payload.completeSavingGoalData,
      };
    case "COMPLETE_SAVING_GOAL_TOTAL_COUNT":
      return {
        ...state,
        completeSavingGoalTotalCount: action.payload.completeSavingGoalTotalCount,
      };  
   case "COMPLETE_SAVING_GOAL_DETAILS_OBJ":
      return {
        ...state,
        completeSavingGoalDetailsObj: action.payload.completeSavingGoalDetailsObj,
      };
    case "HAS_SVG_GOAL_ACCOUNT":
      return {
        ...state,
        hasSVGGoal: action.payload.hasSVGGoal,
      };  
    case "Selected_Notification_Tab":
      return {
        ...state,
        selectedNotificationTab: action.payload.selectedNotificationTab,
      };
    default:
      return state;
  }
};

const persistConfig = {
  key: "root",
  storage: storageSession, // Use session storage to persist the state
  whitelist: [
    "accessToken",
    "userProfile",
    "userCards",
    "loggedInResponse",
    "isLoggedIn",
    "selectedCardDetails",
    "spendAlertsPayload",
    "climbFeatures",
    "deepLinkPath",
    "ssnScreenThrough",
    "savingsTermsConditions",
    "selectedSubIndex", 
    "cancelTransactionDetails",
    "cbkTransactionDetails"
  ], // Specify the state keys you want to persist
};

export default persistReducer(persistConfig, rootReducer);
